// extracted by mini-css-extract-plugin
module.exports = {"benefitItem":"BenefitItem-benefitItem_6e5b192f"};